import { Grid, Typography } from "@mui/material";
import { ReactNode } from "react";

const NoListImgSlide = ({
    identity,
    imgUrl,
    color,
    children,
}: {
    identity: string;
    imgUrl: string;
    color: string;
    children: ReactNode;
}) => (
    <Grid container>
        <Grid item sm={3} xs={12}>
            <img
                style={{
                    width: "100%",
                    display: "block",
                    margin: "auto",
                    maxWidth: 220,
                }}
                alt={identity + " logo"}
                src={imgUrl}
            />
            <Typography style={{ color, textAlign: "center" }} variant="h6">
                {identity.toUpperCase()}
            </Typography>
        </Grid>
        <Grid item sm={9} xs={12}>
            {children}
        </Grid>
    </Grid>
);

export default NoListImgSlide;
